import { render, staticRenderFns } from "./ImportCourseV1JsonDetail.vue?vue&type=template&id=2bfa977c&"
import script from "./ImportCourseV1JsonDetail.vue?vue&type=script&lang=ts&"
export * from "./ImportCourseV1JsonDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports